import {
	AccordionItem,
	AccordionTrigger,
	AccordionContent,
} from '@/components/ui/accordion'
import { cn } from '@/lib/utils'
import { Plus } from 'lucide-react'

interface FaqItemProps {
	question: string
	answer: string
	className?: string
}

export function FaqItem({ question, answer, className }: FaqItemProps) {
	return (
			<AccordionItem
				value={question}
				className={cn('border-b border-[#DDD8E8] bg-transparent', className)}>
				<AccordionTrigger className="gap-5 py-6 text-left font-heading text-lg font-semibold tracking-[-.015em] hover:no-underline [&>svg]:hidden [&[data-state=open]_.faq-plus]:rotate-45 sm:text-xl">
					{question}
					<span className="flex size-9 shrink-0 items-center justify-center rounded-full border border-[#D8D0E8] bg-white text-[#6547D9]">
						<Plus className="faq-plus h-4 w-4 transition-transform duration-200" />
					</span>
				</AccordionTrigger>
				<AccordionContent className="max-w-2xl pb-6 pr-12 text-base leading-7 text-slate-600 sm:text-lg">
					{answer}
			</AccordionContent>
		</AccordionItem>
	)
}
